import React from "react";
const PersonCard = ({image, title}) => {
    return (<div className="flex flex-col items-center text-center">
        <img src={image} alt={title} className="object-cover"/>
    </div>);
};

export default PersonCard;

